import React, { useMemo } from 'react';
import { Box, Card, CardContent, CardHeader, Stack, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

import ThreatMap from 'components/ThreatMap';
import ThreatIcon from 'assets/icons/ThreatIcon';
import { countryCoordinates } from 'components/ThreatMap/coordinates';
import ThreatRegions from './ThreatRegions';

function getTopThreatCountries(threatCountries, count) {
  const weights = { low: 1, medium: 1.2, high: 2, critical: 3 };

  // Calculate severity score for each country
  threatCountries.forEach((country) => {
    const { severity } = country;
    country.severity_score =
      (severity.low || 0) * weights.low +
      (severity.medium || 0) * weights.medium +
      (severity.high || 0) * weights.high +
      (severity.critical || 0) * weights.critical;
  });

  // Sort by severity score in descending order and take top `count` countries
  return threatCountries.sort((a, b) => b.severity_score - a.severity_score).slice(0, count);
}

const ThreatGeoLocation = () => {
  const { severity: threatGeoData, countData } = useSelector((state) => state.ecosystems.ecosystem);

  const { threatCountries, topThreatCountries } = useMemo(() => {
    const mappingResults = [];
    if (threatGeoData?.length) {
      threatGeoData.forEach((threat) => {
        const severity = threat.result;
        const code = threat.attributes.source_country_code;
        const country = countryCoordinates.find((countryCoordinate) => code === countryCoordinate.code);
        if (country) {
          mappingResults.push({ country: country.name, code, severity });
        }
      });
    }
    return { threatCountries: mappingResults, topThreatCountries: getTopThreatCountries(mappingResults, 10) };
  }, [threatGeoData]);

  return (
    <Card sx={{ px: 4, pt: 2, pb: 4 }}>
      <CardHeader title="Threat Geo-location" sx={{ p: 0, pb: 6 }} titleTypographyProps={{ variant: 'h4' }} />
      <CardContent sx={{ bgcolor: '#120027', p: 4 }}>
        <Stack direction="row" alignItems="center" spacing={2}>
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: '6px',
              bgcolor: '#072645',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <ThreatIcon width={40} height={40} color="#FF771D" />
          </Box>
          <Stack>
            <Typography color="#FFF" fontSize={24} data-testid="threat_geo-total_threats">
              {countData?.['total.threats']}
            </Typography>
            <Typography color="#FFF" fontSize={16}>
              Total Threats
            </Typography>
          </Stack>
        </Stack>
        <Stack direction="row" justifyContent="center">
          <ThreatMap countries={threatCountries} />
        </Stack>
        <ThreatRegions threatRegions={topThreatCountries} />
      </CardContent>
    </Card>
  );
};

export default ThreatGeoLocation;
